//@ts-check
import React from 'react';
import Formatter from '../../../formatter';
/**@type {import('../types').DataType<import('./types').EmailBlacklistDataModel>} */

var EMAIL_BLACKLIST_DATA_TYPE = {
  data: {
    by: 'Name',
    dataKey: 'emailBlacklist',
    url: '/backend/emailBlacklist',
    deleteItemUrl: '/backend/emailBlacklist?id={id}',
    idKeyProp: 'Name'
  },
  placeholders: {
    label: function label(data) {
      return data.Name;
    },
    type: function type() {
      return 'email blacklist';
    },
    icon: function icon() {
      return 'email';
    }
  },
  columns: [{
    id: 'Name',
    children: 'Domain',
    formatter: function formatter(_ref) {
      var data = _ref.data;
      if (!data) return null;
      return React.createElement(Formatter.Text, {
        value: data.Name
      });
    }
  }]
};
export default EMAIL_BLACKLIST_DATA_TYPE;